import { render, staticRenderFns } from "./clinic-enable-dialog.vue?vue&type=template&id=ab3676e2&scoped=true"
import script from "./clinic-enable-dialog.vue?vue&type=script&lang=js"
export * from "./clinic-enable-dialog.vue?vue&type=script&lang=js"
import style0 from "./clinic-enable-dialog.vue?vue&type=style&index=0&id=ab3676e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3676e2",
  null
  
)

export default component.exports